import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";

import { useParams, useHistory, Redirect } from "react-router-dom";
import { Formik, Form as FormikForm } from "formik";
import Grid from "@material-ui/core/Grid";
import Button from "@material-ui/core/Button";
// import ListIcon from "@material-ui/icons/List";
import Typography from "@material-ui/core/Typography";
import Divider from "@material-ui/core/Divider";
import { useTranslation } from "react-i18next";
import moment from "moment";
import SaveIcon from "@material-ui/icons/Save";
import CloseIcon from "@material-ui/icons/Close";

import LoadingOverlay from "react-loading-overlay";
import LoadingIcon from "@Components/LoadingIcon/LoadingIcon";
import useStyles from "assets/jss/material-dashboard-react/views/forms/employeeEntryForm";
import eightAxios from "configs/axiosConfig";
import FormikControl from "@Components/FormikControl/FormikControl";
import { fetchDataFromApi, resolveObjectPath } from "utils";
import { useNotifyContext } from "@Components/Notify";
import { PHONE_NUMBER_KEYS } from "configs/constants";
// import { Box } from "@material-ui/core";

const Form = (props) => {
  const { t } = useTranslation();
  const {
    initialValues,
    validationSchema,
    submitUrl,
    listRoute,
    formTitle,
    formFields,
    disabled,
    formButtons,
    isMultipart,
    afterSubmit,
    outerSubmitHandler,
    noTypography,
    noFeature,
    outerConfig,
    errorFromOuterComponent,
    downloadTemplate,
    buttonPosition = undefined, // Represented in integer, this props defines the number of components after which buttons will render
  } = props;
  const classes = useStyles();
  const params = useParams();
  const history = useHistory();
  const [recordForEdit, setRecordForEdit] = useState(null);
  const [errorMsg, setErrorMsg] = useState(null);
  let buttons = [];
  const setNotify = useNotifyContext();
 
  const builtInButtons = {
    save: {
      type: "submit",
      label: t("Save"),
      color: "primary",
      startIcon: <SaveIcon />,
    },
    submit: {
      type: "submit",
      label: t("Submit"),
      color: "primary",
      startIcon: <SaveIcon />,
    },
    reset: {
      type: "reset",
      label: t("Reset"),
    },
    cancel: {
      label: t("Cancel"),
      startIcon: <CloseIcon />,
      onClick: () => history.push(listRoute),
    },
  };
  const getButtons = () => {
    buttons = [];
    if (formButtons) {
      formButtons.forEach((formButton) => {
        if (typeof formButton === "string") {
          buttons.push(builtInButtons[formButton]);
        } else buttons.push(formButton);
      });
    }
  };
  getButtons();


  useEffect(() => {
    
    setTimeout(() => {
      if (params.id) {
        fetchDataFromApi(
          `${submitUrl}${params.id}/${"?from_frontend=true"}`,
          setRecordForEdit,
          false,
          outerConfig ? outerConfig : null
        );
      }    }, 3000);
   
  }, [submitUrl, params.id]);

  const displayButtons = (formik) => {
    return (
      <Grid
        container
        justify="flex-start"
        spacing={3}
        style={{ marginTop: "5px", marginBottom: "5px" }}
      >
        
        {buttons
          ? buttons.map((button, index) => {
              if (
                "renderKey" in button &&
                formik.values[button.renderKey] !== button.renderValue
              ) {
                return null;
              }
              return (
                <Grid key={index} item xs={12} sm={6} md={4} lg={1}   
                >
                  <Button
                    style={{
                      textTransform: "capitalize",
                      borderRadius: 0,
                      padding:"7px 37px 7px ",
                    }}
                    type={button.type}
                    variant="contained"
                    color={button.color}
                    // disabled={formik.isSubmitting}
                    startIcon={button.startIcon}
                    onClick={button.onClick ? () => button.onClick() : null}
                    fullWidth
                  >
                    {t(button.label)}
                  </Button>
                </Grid>
              );
            })
          : null}
        <Grid
          item
          container
          md={4}
          lg={9}
          alignContent="center"
          className={classes.showMandatory}
        >
          {noTypography ? (
            ""
          ) : (
            <Typography variant="subtitle2">
              * {t("Indicates Mandatory Fields")}
            </Typography>
          )}
          
        </Grid>
      </Grid>
    );
  };

  const handleSubmit = (values, { setSubmitting, resetForm }) => {
    let submitVal = values;

    // this conditiion for default value after submitting the worker contract form.

    if(submitVal?.language =='English' && !submitVal?.is_default)
    {
      submitVal.is_default = true
    }
    else{
      submitVal.is_default = false
    }
    submitVal["from_frontend"] = true;
    let apiKeys = Object.keys(submitVal);
   apiKeys.forEach((key) => {
      if (PHONE_NUMBER_KEYS.includes(key)) {
        if (typeof submitVal[key] === "string") {
          if (submitVal[key].substring(0, 2) !== "60") {
            submitVal[key] = "60" + submitVal[key];
          }
        }
      }
    });
    if (isMultipart) {
      let keys = Object.keys(values);
      let data = new FormData();
      keys.forEach((key) => {
        if (Array.isArray(values[key])) {
          values[key].forEach((value) => {
            data.append(key, value);
          });
        } else {
          if (values[key] !== null) data.append(key, values[key]);
        }
      });
      submitVal = data;
    }
    if (values.id === undefined) {
       if (submitUrl == "account-deletion/") {
         setSubmitting(false);       
      } else {
        eightAxios
        .post(submitUrl, submitVal)
        .then((response) => {
          setSubmitting(false);
          setNotify({
            isOpen: true,
            message: "Created Successfully",
            type: "success",
          });
          setTimeout(function () {
            history.push(listRoute);
          }, 2000);
          afterSubmit ? afterSubmit(true) : null;
          
          // resetForm();
        })
        .catch((error) => {
          afterSubmit ? afterSubmit(false) : null;
          setNotify({
            isOpen: true,
            message: error.response.data.message || error.response.email,
            type: "error",
          });
          setErrorMsg(error.response.data);
          setSubmitting(false);
        });
      }
       /* eightAxios
        .post(submitUrl, submitVal)
        .then((response) => {
          setSubmitting(false);
          setNotify({
            isOpen: true,
            message: "Created Successfully",
            type: "success",
          });
          setTimeout(function () {
            history.push(listRoute);
          }, 2000);
          afterSubmit ? afterSubmit(true) : null;
          console.log("test post submit", submitUrl);
          console.log("test post submit val", submitVal);
          
          // resetForm();
        })
        .catch((error) => {
          afterSubmit ? afterSubmit(false) : null;
          console.log("test post submit", submitUrl);
          console.log("test post submit val", submitVal);
          setNotify({
            isOpen: true,
            message: error.response.data.message || error.response.email,
            type: "error",
          });
          setErrorMsg(error.response.data);
          setSubmitting(false);
        });  */
    } 
    else {
      eightAxios
        .patch(`${submitUrl}${params.id}/`, submitVal)
        .then(async (response) => {
          setSubmitting(false);
          
          await setNotify({
            isOpen: true,
            message: "Updated Sucessfully",
            type: "success",
          });

          setTimeout(function () {
            history.push(listRoute);
          }, 2000);

          afterSubmit ? afterSubmit(true) : null;
          // resetForm();
        })
        .catch((error) => {
          afterSubmit ? afterSubmit(false) : null;
          setNotify({
            isOpen: true,
            message: error.response.data.message,
            type: "error",
          });
          setSubmitting(false);
        });
    }
  };
  if (recordForEdit != null && recordForEdit.display_start_datetime) {
    
    
    try {
      recordForEdit[
        "display_start_date"
      ] = recordForEdit.display_start_datetime.slice(0, 10);
      let splitVal = recordForEdit.display_start_datetime
        .slice(11, 19)
        .split(":");
      let time = new Date();
      time.setHours(splitVal[0]);
      time.setMinutes(splitVal[1]);
      time.setSeconds("00");
      recordForEdit["display_start_time"] = time;
      
      
    } catch (err) {
      throw new Error(
        "Invalid datetime format coming from backend which is: " +
          recordForEdit.display_start_datetime
      );
    }
  }

  const editPage = location.pathname.split("/").includes("edit");
  const workerEditPage = location.pathname.split("/").includes("worker");
  const workerGroupEditPage = location.pathname.split("/").includes("custom-worker-group");
  const BackOfficeEditPage = location.pathname.split("/").includes("backoffice");



  const viewDetailsPage = location.pathname.split("/").includes("view-details");
  const formattedTime = recordForEdit ? moment( recordForEdit.modified_at).format('DD/MM/YYYY') : null;


 

  return (
    <Grid container spacing={2}>
      {/*{noListButton ? null : (*/}
      {/*  <Grid item container justify="flex-end" xs={12}>*/}
      {/*    <Button*/}
      {/*      className={classes.listButton}*/}
      {/*      startIcon={<ListIcon />}*/}
      {/*      onClick={() => history.push(listRoute)}*/}
      {/*    >*/}
      {/*      List*/}
      {/*    </Button>*/}
      {/*  </Grid>*/}
      {/*)}*/}
      <Grid
        item
        container
        justify="space-between"
        xs={12}
        className={classes.title}
        alignContent="center"
      >
       
        {/* this condition is only for edit page */}
        {editPage ? (
          <Typography variant="h6" >
            {t(formTitle)} : {t("Update")}
            
          </Typography>
        ) : viewDetailsPage ? (
          <Typography variant="h6">
            {t(formTitle)} : {t("View Details")}

          </Typography>
        ) : (
          <Typography variant="h6">{t(formTitle)}</Typography>
        )}
        
        {/* this condition is for last updated date */}
        {
        workerEditPage && editPage? (

          <Typography variant="h6" >

          {t("Last Updated")} :{t(formattedTime)}
        </Typography> 

        )

       
        :  BackOfficeEditPage && editPage ? (

          <Typography variant="h6" >

          {t("Last Updated")} :{t(formattedTime)}
        </Typography> 

        )
        : workerGroupEditPage && editPage ? (

          <Typography variant="h6">
            {t("Last Updated")} :{t(formattedTime)}

          </Typography>

          
        ) :
        (
          <Typography variant="h6"></Typography>
        )

       }


        

      </Grid>
      <Grid
        item
        container
        className={classes.formContainer}
        alignContent="center"
      >
        {downloadTemplate ? (
          <a href={"#"} onClick={downloadTemplate}>
            {t("Download Sample")}
          </a>
        ) : (
          console.log("no download")
        )}
      </Grid>
      
      <Grid item container className={classes.formContainer}>
        <Formik
          initialValues={recordForEdit ? recordForEdit : initialValues}
          validationSchema={validationSchema ? validationSchema : null}
          onSubmit={outerSubmitHandler ? outerSubmitHandler : handleSubmit}
          validateOnChange={false}
          enableReinitialize
          disabled = {disabled}


        >
          {(formik) => {
            return (
              <FormikForm style={{ width: "100%" }}>
                <LoadingOverlay
                  styles={{
                    overlay: (base) => ({
                      ...base,
                      background: "rgba(0, 0, 0, 0.2)",
                    }),
                  }}
                  active={params.id ? !recordForEdit : null}
                  spinner={<LoadingIcon />}
                >
                  <Grid container spacing={2} justify="flex-start">
                    {formFields.map((field, index) => {
                      if ("renderKey" in field) {
                        if (
                          "renderValue" in field &&
                          formik.values[field.renderKey] !== field.renderValue
                        ) {
                          return null;
                        }
                        if (
                          "renderWithMultipleValuesOfSameKey" in field &&
                          "renderWithUnchangeableState" in field &&
                          recordForEdit &&
                          !field.renderWithMultipleValuesOfSameKey.includes(
                            recordForEdit[field.renderKey]
                          )
                        ) {
                          return null;
                        }
                      }

                      const {
                        type,
                        label,
                        name,
                        showField,
                        required,
                        options,
                        nolabel,
                        yeslabel,
                        gridSize,
                        classes,
                        linkWrapper,
                        requiredValidation,
                        component: Component,
                        ...rest
                      } = field;

                      if (showField == false) {
                        return null
                      }
                      if (type === "component") {
                        return (
                          <Grid
                            key={rest.key ? rest.key : Component}
                            item
                            xs={gridSize ? gridSize.xs : 12}
                            sm={gridSize ? gridSize.sm : 6}
                            md={gridSize ? gridSize.md : 6}
                            lg={gridSize ? gridSize.lg : 3}
                          >
                            <Component
                              value={
                                rest.key
                                  ? resolveObjectPath(rest.key, formik.values)
                                  : null
                              }
                              passedValue={
                                Array.isArray(rest.passValueWithKey)
                                  ? rest.passValueWithKey.map(
                                      (passedKey) => formik.values[passedKey]
                                    )
                                  : formik.values[rest.passValueWithKey]
                              }
                              label={label}
                              name={name}
                              required={required}
                              {...rest}
                            />
                            {!isNaN(buttonPosition) &&
                            parseInt(buttonPosition) === index + 1
                              ? displayButtons(formik)
                              : null}
                          </Grid>
                        );
                      }
                      if (
                        type === "renderonly" ||
                        type === "imagerender" ||
                        type === "audio"
                      ) {
                        let tempData = rest.value
                          ? rest.value
                          : resolveObjectPath(rest.key, formik.values);
                        if (rest.datetime || rest.date) {
                          try {
                            tempData = new Date(tempData);
                            tempData = rest.datetime
                              ? tempData
                                  .toLocaleString("en-AU", { hour12: true })
                                  .toUpperCase()
                              : tempData.toLocaleDateString("en-GB");
                          } catch (e) {
                            tempData = rest.value
                              ? rest.value
                              : resolveObjectPath(rest.key, formik.values);
                          }
                        }
                        return (
                          <Grid
                            key={rest.key}
                            item
                            xs={gridSize ? gridSize.xs : 12}
                            sm={gridSize ? gridSize.sm : 6}
                            md={gridSize ? gridSize.md : 6}
                            lg={gridSize ? gridSize.lg : 3}
                          >
                            <FormikControl
                              control={type}
                              label={t(label)}
                              linkWrapper={
                                rest.valueType === "link"
                                  ? resolveObjectPath(
                                      linkWrapper,
                                      formik.values
                                    )
                                  : null
                              }
                              value={tempData}
                              {...rest}
                            />
                            {!isNaN(buttonPosition) &&
                            parseInt(buttonPosition) === index + 1
                              ? displayButtons(formik)
                              : null}
                          </Grid>
                        );
                      }
                      if (field.type === "title") {
                        return (
                          <Grid
                            key={field.title}
                            item
                            xs={gridSize ? gridSize.xs : 12}
                            sm={gridSize ? gridSize.sm : 12}
                            md={gridSize ? gridSize.md : 12}
                            lg={gridSize ? gridSize.lg : 12}
                          >
                            <FormikControl
                              control={type}
                              title={t(field.title)}
                              required={required}
                              {...rest}
                            />
                            {!isNaN(buttonPosition) &&
                            parseInt(buttonPosition) === index + 1
                              ? displayButtons(formik)
                              : null}
                          </Grid>
                        );
                      }
                      return (
                        
                        <Grid
                          key={name}
                          item
                          xs={gridSize ? gridSize.xs : 12}
                          sm={gridSize ? gridSize.sm : 6}
                          md={gridSize ? gridSize.md : 6}
                          lg={gridSize ? gridSize.lg : 6}
                        >
                          
                          <FormikControl
                            classes={classes}
                            control={type}
                            label={t(label)}
                            name={name}
                            options={options}
                            nolabel={nolabel}
                            errorMessage={
                              errorFromOuterComponent
                                ? errorFromOuterComponent[name]
                                : errorMsg
                                ? errorMsg[name]
                                : null
                            }
                            required={
                              formik.values[requiredValidation] || required
                            }
                            yeslabel={yeslabel}
                            {...rest}
                          />
                          
                          {!isNaN(buttonPosition) &&
                          parseInt(buttonPosition) === index + 1
                            ? displayButtons(formik)
                            : null}
                            
                        </Grid>
                        
                      );
                    })}
                     
                  </Grid>
                  
                 {noFeature ? (
                   <Grid
                   item
                   container
                   md={5}
                   lg={10}
                   alignContent="center"
                   className={classes.showMandatory}
                 >
                  
                    <Typography variant="subtitle2" style={{ fontWeight: 'bold'}}>

                    {t("This feature is not applicable")}
                  </Typography>
                   
                 </Grid>
         
          ):("") }

                  <Divider className={classes.divider} />
                  {(buttonPosition &&
                    !isNaN(buttonPosition) &&
                    parseInt(buttonPosition) >= formFields.length) ||
                  buttonPosition === undefined
                    ? displayButtons(formik)
                    : null}
                </LoadingOverlay>
                
              </FormikForm>
            );
          }}
          
        </Formik>
        
        
      </Grid>
    </Grid>
  );
};

Form.propTypes = {
  initialValues: PropTypes.object,
  validationSchema: PropTypes.object,
  formTitle: PropTypes.string,
  submitUrl: PropTypes.string,
  listRoute: PropTypes.string,
  formFields: PropTypes.array,
  formButtons: PropTypes.array,
  noListButton: PropTypes.bool,
  isMultipart: PropTypes.bool,
  component: PropTypes.func,
  afterSubmit: PropTypes.func,
  requiredValidation: PropTypes.string,
  outerSubmitHandler: PropTypes.func,
  noTypography: PropTypes.bool,
  noFeature: PropTypes.bool,

  outerConfig: PropTypes.object,
  errorFromOuterComponent: PropTypes.object,
  downloadTemplate: PropTypes.func,
  buttonPosition: PropTypes.number,
  key:PropTypes.number,
  disabled: PropTypes.bool,
  enableLastUpdatedDate: PropTypes.bool,

};

export default Form;
